// extracted by mini-css-extract-plugin
module.exports = {"content":"StampSelector_content__3Rs8u","stampContainer":"StampSelector_stampContainer__-jj28"};